<template>
    <v-container v-if="getPermission('customers?.read')" fluid class="b-container">
        <v-sheet class="pa-3">
            <v-row no-gutters align="center" class="pa-5 pt-0">
                <v-col cols="auto">
                    <v-img
                        src="@/assets/customers.png"
                        width="60"
                        height="60"
                    ></v-img>
                </v-col>
                <v-col cols="9" class="pl-5">
                    <h4 v-text="translations.title[lang]"></h4>
                    <div
                        style="font-size: 0.875rem"
                        class="font-weight-medium mt-1"
                        v-text="translations.info[lang]"
                    ></div>
                </v-col>
            </v-row>
            <v-tabs
                v-model="itab"
                color="secondary"
                :vertical="$vuetify.breakpoint.mdAndDown"
            >
                <v-tab
                    :key="0"
                    v-text="translations[tabs[0]][lang]"
                    @click="resetCurrentTab('all')"
                    class="
                        text-capitalize
                        d-flex
                        justify-lg-center justify-start
                        px-3
                    "
                    :class="{ isCurrentTab: currentTab === 'all' }"
                >
                </v-tab>
                <v-tab
                    :key="1"
                    class="
                        text-capitalize
                        d-flex
                        justify-lg-center justify-start
                        px-3
                        droptab
                    "
                    :class="{
                        isCurrentTab: !['all', 'attributes'].includes(
                            currentTab
                        )
                    }"
                >
                    <span v-if="selectedStore">{{ selectedStore.name }}</span>
                    <v-menu class="menu-tab" top left>
                        <template v-slot:activator="{ attrs }">
                            <v-autocomplete
                                class="menu-tab v-tab--active"
                                :items="companyStores"
                                :search-input.sync="searchStores"
                                :loading="companyStoresLoading"
                                item-color="secondary"
                                color="black"
                                v-bind="attrs"
                                autocomplete
                                single-line
                                v-model="selectedStore"
                                item-text="name"
                                item-value="store_id"
                                return-object
                                @click="loadTab()"
                                @change="loadTab()"
                            >
                                <template v-slot:label>
                                    <span>{{ translations.stores[lang] }}</span>
                                </template>
                                <template v-slot:append-item>
                                    <div v-intersect="endIntersect"></div>
                                </template>
                            </v-autocomplete>
                        </template>
                    </v-menu>
                </v-tab>
                <v-tab
                    :key="2"
                    v-text="translations.attributes[lang]"
                    @click="resetCurrentTab('attributes')"
                    class="
                        text-capitalize
                        d-flex
                        justify-lg-center justify-start
                        px-3
                    "
                    :class="{ isCurrentTab: currentTab === 'attributes' }"
                >
                </v-tab>
                <v-tab
                    :key="3"
                    v-text="translations.notifications[lang]"
                    @click="resetCurrentTab('notifications')"
                    class="
                        text-capitalize
                        d-flex
                        justify-lg-center justify-start
                        px-3
                        ml-15
                    "
                    :class="{ isCurrentTab: currentTab === 'notifications' }"
                >
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="currentTab">
                <v-tab-item v-for="tab in tabs" :key="tab" :value="tab">
                    <div v-if="tab === 'all'">
                        <v-toolbar flat height="90">
                            <ExportLinks
                                @exportCSV="exportFile()"
                                @deleteCSV="
                                    deleteExportedFile(
                                        exportedFile.user_store_export_id
                                    )
                                "
                                :buttonStatusCSV="exportCsvStatus"
                                :urlCSV="
                                    exportedFile && exportedFile.url
                                        ? exportedFile.url
                                        : ''
                                "
                                :createdAt="
                                    exportedFile ? exportedFile.created_at : ''
                                "
                                :exportBtnTitle="{
                                    el: 'Λήψη αρχείου CSV',
                                    en: 'Export to CSV',
                                    it: 'Esporta in CSV'
                                }"
                            />

                            <v-btn
                                :disabled="!getPermission('customers.create')"
                                color="secondary"
                                class="text-capitalize ml-2"
                                depressed
                                v-text="translations.addNewCustomer[lang]"
                                @click="openCustomerDialog('create', {})"
                            ></v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="secondary"
                                class="text-capitalize ml-2"
                                depressed
                                v-text="translations.importCustomers[lang]"
                                @click="openImportDialog()"
                            ></v-btn>
                            <ExportLinks
                                v-if="
                                    superUser &&
                                        customerTransactionsExportedFile &&
                                        customerTransactionsExportedFile.url
                                "
                                @deleteCSV="
                                    deleteExportedFile({
                                        type: 'transactions',
                                        id:
                                            customerTransactionsExportedFile.user_store_export_id
                                    })
                                "
                                :buttonStatusCSV="
                                    exportCsvStatusCustomerTransactions
                                "
                                :urlCSV="
                                    customerTransactionsExportedFile &&
                                    customerTransactionsExportedFile.url
                                        ? customerTransactionsExportedFile.url
                                        : ''
                                "
                                :createdAt="
                                    customerTransactionsExportedFile
                                        ? customerTransactionsExportedFile.created_at
                                        : ''
                                "
                                :exportBtnTitle="{
                                    el:
                                        'Λήψη αρχείου CSV με τις συναλλαγές πελάτη',
                                    en: 'Export customer transactions to CSV ',
                                    it: 'Esporta in CSV'
                                }"
                            />

                            <v-spacer></v-spacer>

                            <v-btn
                                :disabled="!getPermission('customers.filters.create')"
                                color="secondary"
                                class="text-capitalize px-5 mr-3"
                                depressed
                                v-text="translations.visibleColumns[lang]"
                                @click="columnsDialog = true"
                            ></v-btn>
                            <v-col cols="12" sm="4" class="pa-0">
                                <b-search-field
                                    v-model="search"
                                ></b-search-field>
                            </v-col>
                        </v-toolbar>
                        <b-data-table
                            :headers="visibleHeaders"
                            :items="pageCustomers"
                            :page.sync="page"
                            @page-sync="p=>page=p"
                            :options.sync="options"
                            @options-sync="o=>options=o"
                            class="b-outlined"
                            :loading="loading"
                        >
                            <template v-slot:item.card_number="{ item }">
                                <div v-if="item.cards.length > 0">
                                    {{ item.cards.toString() }}
                                </div>
                                <div v-else>-</div>
                            </template>
                            <template v-slot:item.total="{ item }">
                                {{
                                    Number(item.current_balance) +
                                        Number(item.redeemed_points)
                                }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-tooltip color="secondary" top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                        :disabled="!getPermission('customers.update')"
                                            color="secondary"
                                            icon
                                            v-on="on"
                                            @click="openCustomerDialog('update', item)"
                                        >
                                            <v-icon
                                                v-text="icons.mdiPencilOutline"
                                            ></v-icon>
                                        </v-btn>
                                    </template>
                                    <span
                                        class="font-weight-bold"
                                        v-text="translations.update[lang]"
                                    ></span>
                                </v-tooltip>
                                <span
                                    v-if="!superUser || showIconsId == item.user_account_id"
                                >
                                    <v-tooltip v-if="superUser" color="secondary" top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                :disabled="!getPermission('customers.update')"
                                                color="secondary"
                                                icon
                                                v-on="on"
                                                @click="
                                                    openChangeMobileDialog(item)
                                                "
                                            >
                                                <v-icon
                                                    v-text="
                                                        icons.mdiCellphoneCog
                                                    "
                                                ></v-icon>
                                            </v-btn>
                                        </template> 
                                        <span
                                            class="font-weight-bold"
                                            v-text="
                                                translations.changeMobile[lang]
                                            "
                                        ></span>
                                    </v-tooltip>
                                    <v-tooltip
                                        v-if="superUser"
                                        color="secondary"
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="secondary"
                                                icon
                                                v-on="on"
                                                @click="
                                                    openUserMergeDialog(item)
                                                "
                                            >
                                                <v-icon
                                                    v-text="icons.mdiMerge"
                                                ></v-icon>
                                            </v-btn>
                                        </template>
                                        <span
                                            class="font-weight-bold"
                                            v-text="'Merge'"
                                        ></span>
                                    </v-tooltip>
                                    <v-tooltip
                                        v-if="getPermission('customers?.read')"
                                        color="secondary"
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="secondary"
                                                icon
                                                v-on="on"
                                                @click="
                                                    openUserTransactionsDialog(
                                                        item
                                                    )
                                                "
                                            >
                                                <v-icon
                                                    v-text="
                                                        icons.mdiAccountCash
                                                    "
                                                ></v-icon>
                                            </v-btn>
                                        </template>
                                        <span
                                            class="font-weight-bold"
                                            v-text="'Transactions'"
                                        ></span>
                                    </v-tooltip>
                                    <v-tooltip
                                        v-if="superUser && item.current_balance"
                                        color="secondary"
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-if="superUser"
                                                color="secondary"
                                                icon
                                                v-on="on"
                                                @click="
                                                    openClearPointsDialog(item)
                                                "
                                            >
                                                <v-icon
                                                    v-text="icons.mdiGiftOff"
                                                ></v-icon>
                                            </v-btn>
                                        </template>
                                        <span
                                            class="font-weight-bold"
                                            v-text="
                                                translations.clearPoints[lang]
                                            "
                                        ></span>
                                    </v-tooltip>
                                    <v-tooltip
                                        v-if="superUser && item.cards != '-'"
                                        color="secondary"
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-if="superUser"
                                                color="secondary"
                                                icon
                                                v-on="on"
                                                @click="
                                                    openDetachCardDialog(item)
                                                "
                                            >
                                                <v-icon
                                                    v-text="
                                                        icons.mdiCardBulletedOff
                                                    "
                                                ></v-icon>
                                            </v-btn>
                                        </template>
                                        <span
                                            class="font-weight-bold"
                                            v-text="
                                                translations.detachCard[lang]
                                            "
                                        ></span>
                                    </v-tooltip>
                                    
                                    <v-tooltip
                                        color="secondary"
                                        top
                                        v-if="getPermission('customers?.delete')"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="secondary"
                                                icon
                                                v-on="on"
                                                @click="
                                                    openDeleteCustomerDialog(item)
                                                "
                                            >
                                                <v-icon
                                                    v-text="
                                                        icons.mdiDeleteAlert
                                                    "
                                                ></v-icon>
                                            </v-btn>
                                        </template>
                                        <span
                                            class="font-weight-bold"
                                            v-text="
                                                translations.deletePermanently[lang]
                                            "
                                        ></span>
                                    </v-tooltip>
                                </span>
                                <span v-else>
                                    <v-tooltip
                                        v-if="superUser"
                                        color="secondary"
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-if="superUser"
                                                color="secondary"
                                                icon
                                                v-on="on"
                                                @click="showActionIcons(item)"
                                            >
                                                <v-icon
                                                    v-text="
                                                        icons.mdiDotsHorizontal
                                                    "
                                                ></v-icon>
                                            </v-btn>
                                        </template>

                                        <span
                                            class="font-weight-bold"
                                            v-text="
                                                translations.moreActions[lang]
                                            "
                                        ></span>
                                    </v-tooltip>
                                </span>
                            </template>
                        </b-data-table>

                        <v-dialog
                            v-model="dialog"
                            :max-width="
                                $vuetify.breakpoint.smAndDown ? '90%' : '40%'
                            "
                        >
                            <CustomerForm v-if="dialog === true"
                                :mode="mode"
                                :modalToggle="modalToggle"
                                @close="dialog = false"
                                @openAddCardDialog="openAddCardDialog"

                            />
                        </v-dialog>

                        <v-dialog v-model="infoDialog" max-width="500">
                            <AdditionalInfo @cancel="infoDialog = false" />
                        </v-dialog>

                        <v-dialog v-model="mergeDialog" max-width="500">
                            <UserMergeDialog @cancel="mergeDialog = false" @merge="startMergeUsers"/>
                        </v-dialog>
                        <v-dialog
                            v-model="transDialog"
                            max-width="1600"
                            min-width="600px"
                        >
                            <UserTransactionsDialog
                                @cancel="transDialog = false"
                            />
                        </v-dialog>

                        <v-dialog v-model="addCardDialog" max-width="500">
                            <b-card
                                :title="translations.addCard[lang]"
                                @cancel="addCardDialog = false"
                                @submit="saveCardNumber()"
                                :submit-text="{
                                    el: 'Αποθήκευση',
                                    en: 'Save',
                                    it: 'Salva'
                                }"
                                :cancel-text="{
                                    el: 'Ακύρωση',
                                    en: 'Cancel',
                                    it: 'Cancella'
                                }"
                            >
                                <v-row no-gutters>
                                    <v-col cols="12" md="12">
                                        <b-text-field
                                            :label="
                                                translations.card_number[lang]
                                            "
                                            v-model="newCardNumber"
                                        ></b-text-field>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <b-text-field
                                            label="CVC"
                                            v-model="newCardCvc"
                                        ></b-text-field>
                                    </v-col>
                                </v-row>
                            </b-card>
                        </v-dialog>
                    </div>
                    <div v-else-if="tab === 'attributes'">
                        <v-toolbar flat height="90">
                            <v-btn
                                color="secondary"
                                class="text-capitalize ml-2"
                                depressed
                                v-text="translations.createNewAttribute[lang]"
                                @click="openAttributesDialog({})"
                            ></v-btn>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-data-table
                            :headers="headersAttributes"
                            :items="attributes"
                            :footer-props="{
                                itemsPerPageOptions: [12],
                                showCurrentPage: true,
                                pageText: `${page * 12 - 11}-${
                                    page * 12 <= attributes.length
                                        ? page * 12
                                        : attributes.length
                                } ${translations.paginationText[lang]} ${
                                    attributes.length
                                }`
                            }"
                            class="b-outlined"
                            :loading="loading"
                        >
                            <template v-slot:item.user_account_attribute_definition_values="{ item }">
                                <div v-if="item.user_account_attribute_definition_values.length > 0">
                                    <div v-if="item.attribute_type == 'radio'">
                                        <v-container class="px-0" fluid>
                                            <v-radio-group row readonly>
                                                <v-radio
                                                    readonly
                                                    v-for="n in item.user_account_attribute_definition_values"
                                                    color="secondary"
                                                    :key="n.user_account_attribute_definition_value_id"
                                                    :label="`${n.value}`"
                                                    :value="n.value"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-container>
                                    </div>
                                    <div v-else>
                                        <v-chip-group
                                            column
                                            class="table-chips"
                                            style="width: 100%;"
                                        >
                                            <v-chip
                                                v-for="(s, i) in item.user_account_attribute_definition_values"
                                                :key="i.user_account_attribute_definition_value_id"
                                                class="font-weight-bold px-1 pr-2 pl-2"
                                                style="overflow: visible;"
                                            >
                                                {{ s.value }}
                                            </v-chip>
                                        </v-chip-group>
                                    </div>
                                </div>
                                <div v-else>-</div>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <v-tooltip color="secondary" top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="secondary"
                                            icon
                                            v-on="on"
                                            @click="openAttributesDialog(item)"
                                        >
                                            <v-icon
                                                v-text="icons.mdiPencilOutline"
                                            ></v-icon>
                                        </v-btn>
                                    </template>

                                    <span
                                        class="font-weight-bold"
                                        v-text="translations.update[lang]"
                                    ></span>
                                </v-tooltip>
                                <v-tooltip color="secondary" top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-if="getPermission('attributes?.delete')"
                                            color="secondary"
                                            icon
                                            v-on="on"
                                            @click="openDeleteAttributeDialog(item)"
                                        >
                                            <v-icon
                                                v-text="icons.mdiDelete"
                                            ></v-icon>
                                        </v-btn>
                                    </template>

                                    <span
                                        class="font-weight-bold"
                                        v-text="translations.delete[lang]"
                                    ></span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                        <v-dialog v-model="attributesDialog" max-width="500">
                            <b-card
                                :title="
                                    translations[
                                        !attributesData.user_account_attribute_definition_id
                                            ? 'createNewAttribute'
                                            : 'editAttribute'
                                    ][lang]
                                "
                                @cancel="attributesDialog = false"
                                @submit="saveAttribute()"
                                :submit-text="translations.save"
                                :cancel-text="translations.cancel"
                                :loading="loading"
                            >
                                <v-row no-gutters>
                                    <v-col cols="12" md="12">
                                        <b-text-field
                                            :label="translations.name[lang]"
                                            v-model="attributesData.name"
                                        ></b-text-field>
                                    </v-col>
                                   
                                    <v-radio-group
                                    class="mt-4 mb-4"
                                        v-model="attributesData.value_type"
                                        row
                                        hide-details
                                        mandatory
                                        :readonly="attributesData.used"
                                        >
                                        <template v-slot:label> <div class="pl-3 pr-3 text-body-2 font-weight-medium">{{ translations.type[lang] }}: </div> </template>
                                        <v-radio
                                            class="mr-10 ml-4"
                                            color="secondary"
                                            :label="translations.text[lang]"
                                            value="text"
                                        ></v-radio>

                                        <v-radio
                                            :label="translations.number[lang]"
                                            color="secondary"
                                            value="number"
                                        ></v-radio>
                                    </v-radio-group>

                                  
                                    <v-col cols="12">
                                        <b-select
                                            :items="attributeOptions"
                                            :label="translations.input[lang]"
                                            :readonly="attributesData.used"
                                            item-text="typeName"
                                            item-value="attribute_type"
                                            v-model="attributesData.attribute_type"
                                        ></b-select>
                                    </v-col>
                                    <v-col
                                        v-if="
                                            selectedAttributeOption.value &&
                                                selectedAttributeOption.value
                                                    .length
                                        "
                                        cols="12"
                                    >
                                        <!-- <v-combobox
                                        class="mt-3"
                                        :items="selectedAttributeOption.value"
                                        menu-props="offsetY"
                                        color="secondary"
                                        item-color="secondary"
                                        clearable
                                        hide-selected
                                        hide-no-data
                                        multiple
                                        chips
                                        deletable-chips
                                        outlined
                                        :label="translations.options[lang]"
                                        v-model="attributesData.options"
                                        ></v-combobox> -->
                                        <v-simple-table
                                            class="mt-4 pr-2 pl-2"
                                            style="border: 1px solid rgb(158, 158, 158)"
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-center">
                                                            <div>
                                                                <span
                                                                    class="font-weight-bold"
                                                                    >{{
                                                                        translations
                                                                            .options[
                                                                            lang
                                                                        ]
                                                                    }} </span
                                                                > 
                                                                <span
                                                                    class="font-weight-medium"
                                                                    >{{
                                                                        translations
                                                                            .for[
                                                                            lang
                                                                        ]
                                                                    }}
                                                                    {{
                                                                        selectedAttributeOption.typeName
                                                                    }}
                                                                </span>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item,
                                                        i) in selectedAttributeOption.value"
                                                        :key="i"
                                                    >
                                                        <td>
                                                            <div
                                                                class="d-flex justify-center align-center mt-2 mb-2"
                                                            >
                                                                <v-text-field
                                                                    autofocus
                                                                    class="no-border-field input-text-center"
                                                                    :label="
                                                                        `${
                                                                            translations
                                                                                .option[
                                                                                lang
                                                                            ]
                                                                        } ${i +
                                                                            1}`
                                                                    "
                                                                    outlined
                                                                    dense
                                                                    color="secondary"
                                                                    hide-details
                                                                    :readonly="attributesData.used&&item.user_account_attribute_definition_value_id"
                                                                    v-model="
                                                                        selectedAttributeOption
                                                                            .value[
                                                                            i
                                                                        ].value
                                                                    "
                                                                    :append-icon="
                                                                      !(attributesData.used && item.user_account_attribute_definition_value_id) && selectedAttributeOption.value.length > 1 && icons.mdiCloseCircle || ''
                                                                    "
                                                                    @click:append="
                                                                        removeAttributeOption(
                                                                            i
                                                                        )
                                                                    "
                                                                ></v-text-field>
                                                            </div>
                                                            <div v-if="attributesData&&attributesData.value_type == 'number' && isNaN(selectedAttributeOption.value[i]?.value)" class="d-flex justify-center mb-2 mt-n2"><span class="error--text">{{ translations.invalidValue[lang] }}</span></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div
                                                                v-if="
                                                                    selectedAttributeOption
                                                                        .value[
                                                                        selectedAttributeOption
                                                                        .value
                                                                            .length -
                                                                            1
                                                                    ]
                                                                "
                                                                class="d-flex justify-center align-center mt-2 mb-2"
                                                            >
                                                                <v-tooltip
                                                                    color="secondary"
                                                                    top
                                                                >
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on
                                                                        }"
                                                                    >
                                                                        <v-btn
                                                                            class="text-capitalize"
                                                                            depressed
                                                                            fab
                                                                            v-on="
                                                                                on
                                                                            "
                                                                            @click="
                                                                                addNewOption()
                                                                            "
                                                                        >
                                                                            <v-icon
                                                                                size="30"
                                                                                v-text="
                                                                                    icons.mdiPlus
                                                                                "
                                                                            ></v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span
                                                                        class="font-weight-bold"
                                                                        v-text="
                                                                            translations
                                                                                .addNewOption[
                                                                                lang
                                                                            ]
                                                                        "
                                                                    ></span>
                                                                </v-tooltip>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>

                                </v-row>
                            </b-card>
                        </v-dialog>

                        <v-dialog
                            v-model="deleteAttributeDialog"
                            max-width="500"
                        >
                            <b-card
                                type="delete"
                                :title="translations.deleteAttribute[lang]"
                                @cancel="deleteAttributeDialog = false"
                                @submit="deletingAttribute()"
                                :submit-text="translations.submit"
                                :cancel-text="translations.cancel"
                                :loading="loading"
                            >
                                <v-row no-gutters>
                                    <v-col cols="12" md="12">
                                        <span>{{
                                            translations
                                                .deleteAttributeConfirmation1[
                                                lang
                                            ]
                                        }}</span>
                                        <v-col cols="12" md="12">
                                            <v-row
                                                v-if="
                                                    deletingAttributeData.user_account_attribute_definition_id
                                                "
                                            >
                                                <v-col cols="12" md="12"
                                                    ><span
                                                        class="font-weight-bold pr-2"
                                                        >ID:</span
                                                    >
                                                    {{
                                                        deletingAttributeData.user_account_attribute_definition_id
                                                    }}</v-col
                                                >
                                                <v-col cols="12" md="12"
                                                    ><span
                                                        class="font-weight-bold pr-2"
                                                        >{{
                                                            translations.name[
                                                                lang
                                                            ]
                                                        }}:</span
                                                    >
                                                    {{
                                                        deletingAttributeData.name
                                                    }}</v-col
                                                >
                                                <v-col cols="12" md="12"
                                                    ><span
                                                        class="font-weight-bold pr-2"
                                                        >{{
                                                            translations.type[
                                                                lang
                                                            ]
                                                        }}:</span
                                                    >
                                                    {{
                                                        deletingAttributeData.attribute_type
                                                    }}</v-col
                                                >
                                                <v-col
                                                    v-if="
                                                        deletingAttributeData.options &&
                                                        deletingAttributeData
                                                                .options.length
                                                    "
                                                    cols="12"
                                                    md="12"
                                                    class="d-flex flex-row "
                                                    ><span
                                                        class="font-weight-bold pr-3 pt-2 mt-1"
                                                        >{{
                                                            translations
                                                                .options[lang]
                                                        }}:</span
                                                    > <div v-if="deletingAttributeData.attribute_type == 'radio'">
                                                            <v-container class="px-0 pt-0 pb-0" fluid>
                                                                <v-radio-group row readonly class="mt-0">
                                                                    <v-radio
                                                                        readonly
                                                                        v-for="n in deletingAttributeData.options"
                                                                        color="secondary"
                                                                        :key="n"
                                                                        :label="`${n}`"
                                                                        :value="n"
                                                                    ></v-radio>
                                                                </v-radio-group>
                                                            </v-container>
                                                        </div>
                                                        <div v-else style="max-width: 400px" >
                                                            <v-chip-group
                                                                column
                                                                class="table-chips"
                                                            >
                                                                <v-chip
                                                                    v-for="(s, i) in deletingAttributeData.options"
                                                                    :key="i"
                                                                    class="font-weight-bold px-1 pr-2 pl-2"
                                                                    style="overflow: auto; max-width: 380px;"
                                                                >
                                                                    {{ s }}
                                                                </v-chip>
                                                            </v-chip-group>
                                                        </div>
                                                   
                                                    </v-col
                                                >
                                            </v-row>
                                        </v-col>
                                    </v-col>
                                </v-row>
                            </b-card>
                        </v-dialog>
                    </div>
                    <div v-else-if="tab === 'notifications'">
                        <NotificationsTab v-if="currentTab === 'notifications'"/>
                    </div>
                    <div v-else>
                        <v-toolbar flat height="90">
                            <ExportLinks
                                @exportCSV="
                                    exportFile({
                                        child_id: selectedStore.store_id
                                    })
                                "
                                @deleteCSV="
                                    deleteExportedFile(
                                        exportedFile.user_store_export_id
                                    )
                                "
                                :buttonStatusCSV="exportCsvStatus"
                                :urlCSV="
                                    exportedFile && exportedFile.url
                                        ? exportedFile.url
                                        : ''
                                "
                                :createdAt="
                                    exportedFile ? exportedFile.created_at : ''
                                "
                            />

                            <v-spacer></v-spacer>

                            <v-col cols="12" sm="4" class="pa-0">
                                <b-search-field
                                    v-model="search"
                                ></b-search-field>
                            </v-col>
                        </v-toolbar>
                        <v-data-table
                            :headers="headersStores"
                            :items="pageStoreCustomers"
                            :footer-props="{
                                itemsPerPageOptions: [12],
                                showCurrentPage: true,
                                pageText: `${page * 12 - 11}-${
                                    page * 12 <= serverItemsLength
                                        ? page * 12
                                        : serverItemsLength
                                } ${
                                    translations.paginationText[lang]
                                } ${serverItemsLength}`
                            }"
                            :page.sync="page"
                            :server-items-length="serverItemsLength"
                            :options.sync="optionsStoreCustomers"
                            class="b-outlined"
                            :loading="loading"
                        >
                        </v-data-table>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-sheet>
        <v-dialog v-model="columnsDialog" max-width="500">
            <b-card
                :title="translations.visibleColumns[lang]"
                :cancel-text="{ el: 'Κλείσιμο', en: 'close', it: 'Chiudi' }"
                @cancel="columnsDialog = false"
                :submitBtn="false"
            >
                <div class="subtitle-1 font-weight-medium pl-2">
                    <v-checkbox
                        v-for="(column, index) in visibleColumns"
                        :key="index"
                        color="secondary"
                        class="mt-3 pt-0"
                        hide-details
                        v-model="column.isVisible"
                    >
                        <template v-slot:label>
                            <h4 class="subtitle-2" v-if="translations[column.column]">
                                <!-- {{ translations[header.translationKey][lang] }} -->
                                {{ translations[column.column][lang] }}
                            </h4>
                        </template>
                    </v-checkbox>
                </div>
            </b-card>
        </v-dialog>
        <v-dialog v-model="changeMobileDialog" max-width="500">
            <b-card
                :title="translations.changeMobile[lang]"
                @cancel="closeChangeMobileDialog()"
                @submit="saveNewMobile()"
                :submit-text="translations.save"
                :cancel-text="translations.cancel"
                :loading="loading"
            >
                <v-row no-gutters>
                    <v-col cols="12" md="12">
                        <b-text-field
                            :label="translations.mobile[lang]"
                            v-model="newMobile"
                        ></b-text-field>
                    </v-col>
                </v-row>
            </b-card>
        </v-dialog>

        <v-dialog v-model="clearPointsDialog" max-width="500">
            <b-card
                :title="translations.clearPoints[lang]"
                @cancel="closeClearPointsDialog()"
                @submit="removeAllPoints()"
                :submit-text="translations.submit"
                :cancel-text="translations.cancel"
                :loading="loading"
            >
                <v-row no-gutters>
                    <v-col cols="12" md="12">
                        <span>{{
                            translations.clearPointsConfirmation1[lang]
                        }}</span>
                        <v-col cols="12" md="12">
                            <v-row v-if="clearPointsCustomer">
                                <v-col cols="12" md="12"
                                    ><span class="font-weight-bold">{{
                                        translations.user_account_id[lang]
                                    }}</span
                                    >:
                                    {{
                                        clearPointsCustomer.user_account_id
                                    }}</v-col
                                >
                                <v-col cols="12" md="12"
                                    ><span class="font-weight-bold">{{
                                        translations.card_number[lang]
                                    }}</span
                                    >:
                                    {{ clearPointsCustomer.card_number }}</v-col
                                >
                                <v-col cols="12" md="12"
                                    ><span class="font-weight-bold">{{
                                        translations.mobile[lang]
                                    }}</span
                                    >: {{ clearPointsCustomer.mobile }}</v-col
                                >
                                <v-col cols="12" md="12"
                                    ><span class="font-weight-bold">{{
                                        translations.email[lang]
                                    }}</span
                                    >: {{ clearPointsCustomer.email }}</v-col
                                >
                                <v-col cols="12" md="12"
                                    ><span class="font-weight-bold">{{
                                        translations.current_balance[lang]
                                    }}</span
                                    >:
                                    {{
                                        clearPointsCustomer.current_balance
                                    }}</v-col
                                >
                            </v-row>
                        </v-col>
                    </v-col>
                </v-row>
            </b-card>
        </v-dialog>

        <v-dialog v-model="detachCardDialog" max-width="500">
            <b-card
                :title="translations.detachCard[lang]"
                @cancel="closeDetachCardDialog()"
                @submit="detachCustomerCard()"
                :submit-text="translations.submit"
                :cancel-text="translations.cancel"
                :loading="loading"
            >
                <v-row no-gutters>
                    <v-col cols="12" md="12">
                        <span>{{
                            translations.detachCardConfirmation1[lang]
                        }}</span>
                        <v-col cols="12" md="12">
                            <v-row v-if="detachCardCustomer">
                                <v-col cols="12" md="12"
                                    ><span class="font-weight-bold">{{
                                        translations.user_account_id[lang]
                                    }}</span
                                    >:
                                    {{
                                        detachCardCustomer.user_account_id
                                    }}</v-col
                                >
                                <v-col
                                    v-if="detachCardCustomer.card_number"
                                    cols="12"
                                    md="12"
                                    ><span class="font-weight-bold">{{
                                        translations.card_number[lang]
                                    }}</span
                                    >:
                                    {{ detachCardCustomer.card_number }}</v-col
                                >
                                <v-col v-else cols="12">
                                    <b-select
                                        :items="detachCardCustomer.cards"
                                        :label="translations.card_number[lang]"
                                        v-model="detachCardCustomer.card_number"
                                    ></b-select>
                                </v-col>
                                <v-col cols="12" md="12"
                                    ><span class="font-weight-bold">{{
                                        translations.mobile[lang]
                                    }}</span
                                    >: {{ detachCardCustomer.mobile }}</v-col
                                >
                                <v-col cols="12" md="12"
                                    ><span class="font-weight-bold">{{
                                        translations.email[lang]
                                    }}</span
                                    >: {{ detachCardCustomer.email }}</v-col
                                >
                                <v-col cols="12" md="12"
                                    ><span class="font-weight-bold">{{
                                        translations.current_balance[lang]
                                    }}</span
                                    >:
                                    {{
                                        detachCardCustomer.current_balance
                                    }}</v-col
                                >
                            </v-row>
                        </v-col>
                    </v-col>
                </v-row>
            </b-card>
        </v-dialog>
        <v-dialog v-model="importDialog" max-width="500">
            <b-standard-card
                :title="translations.importCustomers[lang]"
                :cancel-text="translations.cancel"
                :submit-text="translations.submit"
                :loading="loading"
                class="mt-5"
                height="auto"
                :error-message="errorMessage"
                @submit="uploadCustomersFile()"
                @cancel="importDialog = false"
            >
                {{ translations.importCustomersDescription[lang] }}

                <v-row no-gutters align="center" class="mt-3">
                    <v-col cols="5" class="pr-2"> </v-col>
                    <v-col cols="11" class="pl-2">
                        <v-file-input
                            color="secondary"
                            class="mt-1"
                            outlined
                            dense
                            hide-details="auto"
                            v-model="customersFile"
                        ></v-file-input>
                    </v-col>
                </v-row>
            </b-standard-card>
        </v-dialog>
        
        <v-dialog
            v-model="deleteCustomerDialog"
            max-width="500"
        >
            <b-card
                type="delete"
                :title="translations.deleteCustomer[lang]"
                @cancel="deleteCustomerDialog = false"
                @submit="deletingCustomer()"
                :submit-text="translations.submit"
                :cancel-text="translations.cancel"
                :loading="loading"
            >
                <v-row no-gutters>
                    <v-col cols="12" md="12">
                        <span>{{
                            translations
                                .deleteCustomerConfirmation1[
                                lang
                            ]
                        }}</span>
                        <v-col cols="12" md="12">
                            <v-row
                                v-if="
                                    deletingCustomerData.user_account_id
                                "
                            >
                                <v-col cols="12" md="12"
                                    ><span
                                        class="font-weight-bold pr-2"
                                        >ID:</span
                                    >
                                    {{
                                        deletingCustomerData.user_account_id
                                    }}</v-col
                                >
                                <v-col v-if="deletingCustomerData.first_name != '-' || deletingCustomerData.last_name != '-'" cols="12" md="12"
                                    ><span
                                        class="font-weight-bold pr-2"
                                        >{{
                                            translations.name[
                                                lang
                                            ]
                                        }}:</span
                                    >
                                    {{
                                        `${deletingCustomerData.first_name == '-' ? '' : deletingCustomerData.first_name} ${deletingCustomerData.last_name == '-' ? '' : deletingCustomerData.last_name}`
                                    }}</v-col
                                >
                                <v-col cols="12" md="12"
                                    ><span
                                        class="font-weight-bold pr-2"
                                        >{{
                                            translations.mobile[
                                                lang
                                            ]
                                        }}:</span
                                    >
                                    {{
                                        deletingCustomerData.mobile
                                    }}</v-col
                                >
                            </v-row>
                        </v-col>
                    </v-col>
                </v-row>
            </b-card>
        </v-dialog>
      
    </v-container>
</template>

<script>
import {
    mdiPlus,
    mdiMagnify,
    mdiPencilOutline,
    mdiEye,
    mdiMerge,
    mdiAccountCash,
    mdiCellphoneCog,
    mdiGiftOff,
    mdiCardBulletedOff,
    mdiDotsHorizontal,
    mdiDelete,
    mdiCloseCircle,
    mdiDeleteAlert
} from "@mdi/js";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import CustomerForm from "@/components/loyaltyPanel/customers/CustomerForm.vue";
import AdditionalInfo from "@/components/loyaltyPanel/customers/AdditionalInfo.vue";
import UserMergeDialog from "@/components/loyaltyPanel/customers/UserMergeDialog.vue";
import UserTransactionsDialog from "@/components/loyaltyPanel/customers/UserTransactionsDialog.vue";
import translations from "@/utils/translations/loyaltyPanel/customers";
import debounce from "lodash/debounce";
import ExportLinks from "@/components/general/ExportLinks.vue";
import NotificationsTab from "@/components/loyaltyPanel/customers/NotificationsTab.vue";
import { cloneDeep } from "lodash";

export default {
    name: "Customer",

    components: {
        CustomerForm,
        AdditionalInfo,
        ExportLinks,
        UserMergeDialog,
        UserTransactionsDialog,
        NotificationsTab
    },

    mixins: [translations],

    data() {
        return {
            icons: {
                mdiPlus,
                mdiMagnify,
                mdiPencilOutline,
                mdiEye,
                mdiMerge,
                mdiAccountCash,
                mdiCellphoneCog,
                mdiGiftOff,
                mdiCardBulletedOff,
                mdiDotsHorizontal,
                mdiDelete,
                mdiCloseCircle,
                mdiDeleteAlert
            },
            itab: 0,
            storeTab: "null",
            tabs: ["all", null, "attributes","notifications"],
            currentTab: "all",

            // stores: [],
            selectedCustomer: {},
            selectedStore: {},
            selectedStoreCustomer: {},
            search: "",
            searchStores: "",
            // searchStoreCustomers: "",
            mode: 'create',
            page: +this.$route.query.page,
            storesPage: 1,
            infoDialog: false,
            mergeDialog: false,
            transDialog: false,
            mergeUserId: null,
            transUserId: null,
            infoDialogStore: false,
            filtersData: {
                order: null
            },
            filtersDataStore: {
                order: null
            },
            options: {},
            optionsStore: {},
            optionsStoreCustomers: {},
            exportCsvStatus: 1,
            exportCsvStatusStore: 1,
            exportCsvStatusCustomerTransactions: 1,
            addCardDialog: false,
            addCardCustomer: null,
            columnsDialog: false,
            newCardNumber: null,
            newCardCvc: null,
            modalToggle: false,
            changeMobileUserAccount: null,
            changeMobileDialog: false,
            newMobile: "",
            clearPointsDialog: false,
            clearPointsCustomer: null,
            detachCardDialog: false,
            detachCardCustomer: null,
            importDialog: false,
            customersFile: null,
            showIconsId: null,
            searchAttributes: "",
            attributesDialog: false,
            attributesData: { options: [] },
            deletingAttributeData: { options: [] },
            deleteAttributeDialog: false,
            deletingCustomerData: {},
            deleteCustomerDialog: false,
            attributeOptions: [
                {
                    name: "",
                    typeName: "Text",
                    attribute_type: "text",
                    value: []
                },
                {
                    name: "",
                    typeName: "Select One",
                    attribute_type: "select",
                    value: [{
                            "user_account_attribute_definition_value_id": null,
                            "value": null
                        }]
                },
                {
                    name: "",
                    typeName: "Select Multiple",
                    attribute_type: "multi_select",
                    value: [{
                            "user_account_attribute_definition_value_id": null,
                            "value": null
                        }]
                },
                {
                    name: "",
                    typeName: "Radio Buttons",
                    attribute_type: "radio",
                    value: [{
                            "user_account_attribute_definition_value_id": null,
                            "value": null
                        }]
                }
            ]
        };
    },

    computed: {
        ...mapState([
            "loading",
            "superUser",
            "errorMessage",
            "serverItemsLength",
            "exportCSVStatus","permissions","storePermissions", "user"
        ]),

        ...mapState("loyaltyPanel", ["company"]),

        ...mapState("loyaltyPanel/customers", [
            "exportedFile",
            "customerTransactionsExportedFile",
            "companyStoresLoading",
            "companyStores",
            "customers",
            "attributes"
        ]),
        ...mapState("loyaltyPanel/notifications", [
            "exportNotificationFileCreated",
        ]),

        lang() {
            return this.$route.params.lang;
        },
        stores: {
            get() {
                return this.companyStores;
            }
        },
        visibleColumns: {
            get() {
                return this.$store.state.loyaltyPanel.customers.visibleColumns;
            },
            set(val) {
                this.setVisibleColumns(val);
            }
        },


        pageCustomers() {
            return (
                this.customers.map(e => {
                    for (let [k, v] of Object.entries(e)) {
                        e[k] = v || "-";
                    }
                    return {
                        ...e,
                        mobile: e.mobile && !isNaN(e.mobile) ? e.mobile : "-"
                    };
                }) || []
            );
        },
        pageStoreCustomers() {
            return (
                this.storeCustomers.map(e => {
                    for (let [k, v] of Object.entries(e)) {
                        e[k] = v || "-";
                    }
                    return {
                        ...e,
                        mobile: e.mobile && !isNaN(e.mobile) ? e.mobile : "-"
                    };
                }) || []
            );
        },

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            }
        },

        panelType: {
            get() {
                return this.$store.state.panelType;
            },
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }
            if (this.search) {
                query += `q=${this.search}&`;
            }
            return query.slice(0, query.length - 1);
        },

        attributesQuery() {
            return this.searchAttributes ? `?q=${this.searchAttributes}` : "";
        },

        storesQuery() {
            if (this.searchStores) {
                return `?q=${this.searchStores}&page=${this.storesPage}`;
            }
            return `?page=${this.storesPage}`;
        },

        headers() {
            let headerData = [
                {
                    text: this.translations.user_account_id[this.lang],
                    value: "user_account_id",
                    width: 140
                },
                {
                    text: this.translations.card_number[this.lang],
                    value: "card_number",
                    width: 140,
                    maxWidth: 140
                },
                {
                    text: this.translations.mobile[this.lang],
                    value: "mobile",
                    width: 110
                },
                {
                    text: this.translations.email[this.lang],
                    value: "email",
                    width: 140
                },
                {
                    text: this.translations.firstName[this.lang],
                    value: "first_name",
                    width: 100
                },
                {
                    text: this.translations.lastName[this.lang],
                    value: "last_name",
                    width: 120
                },
                {
                    text: this.translations.total_transactions[this.lang],
                    value: "total_transactions",
                    width: 140
                },
                // { text: this.translations.total[this.lang], value: "total" },
                {
                    text: this.translations.redeemed_points[this.lang],
                    value: "redeemed_points",
                    width: 170
                },
                {
                    text: this.translations.current_balance[this.lang],
                    value: "current_balance",
                    width: 160
                },
                {
                    text: this.translations.total_price[this.lang],
                    value: "total_price",
                    width: 140
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                    sortable: false,
                    width: 100
                }
            ];
            if (this.superUser) {
                headerData.splice(-1, 0, {
                    text: this.translations.user_id[this.lang],
                    value: "user_id",
                    sortable: false,
                    isVisible: true,
                    width: 100
                });
            }
            return headerData;
        },

        visibleHeaders() {
            let visibleHeaders = this.headers.map(e => ({
                ...(this.visibleColumns.find(x => x.column === e.value) || {}),
                ...e
            }));
            return visibleHeaders.filter(e => e && e.isVisible);
        },

        headersStores() {
            return [
                {
                    text: this.translations.mobile[this.lang],
                    value: "mobile",
                    width: 100
                },
                {
                    text: "email",
                    value: "email",
                    width: 100
                },
                {
                    text: this.translations.firstName[this.lang],
                    value: "first_name",
                    width: 100
                },
                {
                    text: this.translations.lastName[this.lang],
                    value: "last_name",
                    width: 120
                },
                {
                    text: this.translations.cardNumbersActivated[this.lang],
                    value: "card_numbers_activated",
                    width: 200
                },
                {
                    text: this.translations.transactions[this.lang],
                    value: "total_transactions",
                    width: 150
                },
                {
                    text: this.translations.storePoints[this.lang],
                    value: "total_points",
                    width: 150
                },
                {
                    text: this.translations.total_price[this.lang],
                    value: "total_price",
                    width: 150
                }
            ];
        },

        headersAttributes() {
            return [
                {
                    text: "ID",
                    value: "user_account_attribute_definition_id",
                    width: 100
                },
                {
                    text: this.translations.name[this.lang],
                    value: "name",
                    width: 200
                },
                {
                    text: this.translations.input[this.lang],
                    value: "attribute_type",
                    width: 150
                },
                {
                    text: this.translations.type[this.lang],
                    value: "value_type",
                    width: 150
                },
                {
                    text: this.translations.options[this.lang],
                    value: "user_account_attribute_definition_values",
                    width: 200
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                    width: 100
                }
            ];
        },

        sendingData() {
            return {
                query: this.query,
                filters: this.filtersData,
                itab: this.itab,
                store_id: this.selectedStore.store_id
            };
        },
        ...mapGetters("loyaltyPanel/customers", [
            "customers",
            "storeCustomers"
        ]),

        selectedAttributeOption() {
            return (
                this.attributeOptions.find(
                    x => x.attribute_type == this.attributesData.attribute_type
                ) || {}
            );
        },
        
    },

    methods: {
        ...mapMutations([
            "setResetValidation",
            "setResetSuccess",
            "setExportCSVStatus",
            "setNotification"
        ]),
        ...mapMutations("loyaltyPanel/customers", [
            "setCustomerData",
            "setMergeDialogMobile",
            "setTransDialogUserAccId",
            "setTransDialogUserId",
            "setVisibleColumns",
            "setAttributes"
        ]),
        ...mapActions("loyaltyPanel/customers", [
            "loadCustomers",
            "loadStoreCustomers",
            "getCustomerProfile",
            "getExportedFileStatus",
            "exportFile",
            "deleteExportedFile",
            "loadStores",
            "addNewCardNumber",
            "updateMobile",
            "removePoints",
            "detachCard",
            "importCustomers",
            "loadCardStatus",
            "getAttributes",
            "createAttribute",
            "updateAttribute",
            "deleteAttribute",
            "deleteCustomer", 
            "mergeUsers"
        ]),
        ...mapMutations([
            "setDialog",
            "setDeleteDialog",
            "setResetSuccess",
            "setResetValidation"
        ]),
        ...mapActions(["getPermission"]),

        getPermission(path) {
            return this.superUser || (
                eval("this.permissions." + path) &&
                eval("this.storePermissions." + path)
            );
        },

        openCustomerDialog(mode, item) {
            this.modalToggle = !this.modalToggle;
            this.mode = mode;
            if (mode == 'create') {
                this.setCustomerData({});
                this.dialog = true;
            } else if (mode == 'update') {
                this.getCustomerProfile({ id: item.user_account_id, mode: 'update' });
            }
            setTimeout(() => this.setResetSuccess(true), 300);
            this.setResetValidation(true);
        },
        openAttributesDialog(item) {
            this.attributesData = cloneDeep(item);
            this.attributesData.options = this.attributesData.options || [];
            if (this.attributesData.options?.[0]) {
                this.selectedAttributeOption.value = [
                    ...this.attributesData.user_account_attribute_definition_values
                ];
            }
            this.attributesDialog = true;
        },

        openDeleteAttributeDialog(item) {
            this.deletingAttributeData = cloneDeep(item);
            this.deleteAttributeDialog = true;
        },

        openDeleteCustomerDialog(item) {
            this.deletingCustomerData = cloneDeep(item);
            this.deleteCustomerDialog = true;
        },

        openImportDialog() {
            this.importDialog = true;
        },

        async uploadCustomersFile() {
            let res = await this.importCustomers(this.customersFile);
            if (res && !res.error) {
                this.setNotification({
                    show: true,
                    type: "success",
                    text: res?.success || "Success"
                });
                this.customersFile = null;
                await this.loadCustomers(this.sendingData);
            }
            this.importDialog = false;
        },
        addNewOption() {
            this.selectedAttributeOption.value.push({
                user_account_attribute_definition_value_id: null,
                value: null
            })
        },
        openChangeMobileDialog(item) {
            this.changeMobileUserAccount = { ...item };
            this.changeMobileDialog = true;
        },

        closeChangeMobileDialog() {
            this.changeMobileUserAccount = null;
            this.newMobile = "";
            this.changeMobileDialog = false;
        },

        async saveNewMobile() {
            if (this.changeMobileUserAccount?.user_account_id) {
                let res = await this.updateMobile({
                    user_account_id: this.changeMobileUserAccount
                        .user_account_id,
                    mobile: this.newMobile
                });
                if (res && !res.error) {
                    this.setNotification({
                        show: true,
                        type: "success",
                        text: res?.success || "Success"
                    });
                    this.loadCustomers(this.sendingData);
                }
            }
            this.closeChangeMobileDialog();
        },

        openClearPointsDialog(item) {
            this.clearPointsCustomer = { ...item };
            this.clearPointsDialog = true;
        },

        closeClearPointsDialog() {
            this.clearPointsCustomer = null;
            this.clearPointsDialog = false;
        },

        async removeAllPoints() {
            if (this.clearPointsCustomer?.user_account_id) {
                let res = await this.removePoints(
                    this.clearPointsCustomer.user_account_id
                );
                if (res && !res.error) {
                    this.setNotification({
                        show: true,
                        type: "success",
                        text: res?.success || "Success"
                    });
                    this.loadCustomers(this.sendingData);
                }
            }
            this.closeClearPointsDialog();
        },

        openDetachCardDialog(item) {
            this.detachCardCustomer = { ...item };
            this.detachCardCustomer.card_number = null;
            if (this.detachCardCustomer.cards.length === 1) {
                this.detachCardCustomer.card_number = this.detachCardCustomer.cards[0];
            }
            this.detachCardDialog = true;
        },

        closeDetachCardDialog() {
            this.detachCardCustomer = null;
            this.detachCardDialog = false;
        },

        async detachCustomerCard() {
            if (this.detachCardCustomer?.user_account_id) {
                let res = await this.detachCard(this.detachCardCustomer);
                if (res && !res.error) {
                    this.setNotification({
                        show: true,
                        type: "success",
                        text: res?.success || "Success"
                    });
                    this.loadCustomers(this.sendingData);
                }
            }
            this.closeDetachCardDialog();
        },

        openUserMergeDialog(item) {
            this.setMergeDialogMobile(item.mobile);
            this.mergeUserId = item.mobile;
            this.mergeDialog = true;
        },

        openUserTransactionsDialog(item) {
            this.setTransDialogUserAccId(item.user_account_id);
            this.setTransDialogUserId(item.user_id);
            this.transUserId = item.user_account_id;
            this.transDialog = true;
        },

        handleSearch() {
            let sendingData = {
                query: `?q=${this.search}`,
                filters: this.filtersData
            };
            this.loadCustomers(this.sendingData);
        },

        handleSearchAttributes() {
            this.getAttributes(this.attributesQuery);
        },

        getFilteredData() {
            let sendingData = {
                query: this.query,
                filters: this.filtersData,
                itab: this.itab,
                store_id: this.selectedStore.store_id
            };
            this.loadCustomers(this.sendingData);
        },

        loadTab() {
            if (!this.selectedStore) return;
            let tabIndex = this.tabs.findIndex(
                x => x === this.selectedStore.name
            );

            if (tabIndex < 0) {
                this.tabs[1] = this.selectedStore.name;
                tabIndex = 1;
            }
            this.itab = 1;
            this.$nextTick(() => {
                this.currentTab = this.selectedStore.name;
            });
            this.$nextTick(() => {
                this.itab = 1;
            });
            this.$nextTick(() => {
                this.loadCustomers(this.sendingData);
            });
            this.search = "";
        },

        resetCurrentTab(name) {
            let i = this.tabs.findIndex(x => x === name);
            this.itab = i;
            this.search = "";
            this.currentTab = name;
            this.$nextTick(() => {
                this.currentTab = name;
            });
            this.$nextTick(() => {
                this.itab = i;
            });
            if (name === "all") {
                this.loadCustomers(this.sendingData);
            }
            if (name === "attributes") {
                this.getAttributes(this.attributesQuery);
            }
        },

        handleStoreSearch() {
            this.loadStores({
                query: `?q=${this.searchStores}`,
                page: this.storesPage
            });
        },

        loadMoreStores() {
            if (!this.searchStores || this.searchStores.length > 2) {
                this.storesPage++;
                this.loadStores({
                    query: this.storesQuery,
                    page: this.storesPage
                });
            }
        },

        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.loadMoreStores();
            }
        },

        openAddCardDialog(customer) {
            this.dialog = false;
            this.addCardDialog = true;
            this.addCardCustomer = customer;
        },

        async saveCardNumber() {
            const body = {
                company_id: this.company.store_id,
                user_account_id: this.addCardCustomer.user_account_id,
                card_number: this.newCardNumber
            };
            await this.addNewCardNumber(body);
            this.addCardDialog = false;
        },

        showActionIcons(item) {
            this.showIconsId = item.user_account_id;
        },

        async deletingAttribute() {
            let res = this.deleteAttribute(
                this.deletingAttributeData.user_account_attribute_definition_id
            );
            if (res && !res.error) {
                this.setNotification({
                    show: true,
                    type: "success",
                    text: this.translations.deleteAttributeSuccess[this.lang]
                });
                this.deletingAttributeData = {};
                this.deleteAttributeDialog = false;
            } else {
                this.setNotification({
                    show: true,
                    type: "error",
                    text: res?.message || "Error"
                });
            }
        },
        

        async saveAttribute() {
            let id = this.attributesData.user_account_attribute_definition_id;
            let res;
            if (id) {
                res = await this.updateAttribute({ ...this.attributesData });
            } else {
                res = await this.createAttribute({ ...this.attributesData });
            }

            if (res && !res.error) {
                await this.getAttributes();
                this.setNotification({
                    show: true,
                    type: "success",
                    text: this.translations[
                        id ? "updateAttributeSuccess" : "createAttributeSuccess"
                    ][this.lang]
                });
                this.attributesData = { options: [] };
                this.attributesDialog = false;
            } else {
                this.setNotification({
                    show: true,
                    type: "error",
                    text: res?.message || "Error"
                });
            }
        },
        removeAttributeOption(i) {
            this.selectedAttributeOption.value.splice(i, 1);
            this.attributesData.options.splice(i, 1);
        },
        

        async deletingCustomer() {
            let res = this.deleteCustomer(
                this.deletingCustomerData.user_account_id
            );
            if (res && !res.error) {
                this.setNotification({
                    show: true,
                    type: "success",
                    text: this.translations.deleteCustomerSuccess[this.lang]
                });
            } else {
                this.setNotification({
                    show: true,
                    type: "error",
                    text: res?.message || "Error"
                });
            }
            
            this.deletingCustomerData = {};
            this.deleteCustomerDialog = false;
        },
        
        async startMergeUsers(body) {
                let res = await this.mergeUsers(body);
                if (res?.data && !res.data.error) {
                    this.getFilteredData();
                    this.setNotification({
                        show: true,
                        type: "success",
                        text: this.translations.mergeSuccess[this.lang]
                    });
                    this.mergeDialog = false
                } else {
                this.setNotification({
                    show: true,
                    type: "error",
                    text: res?.data?.message || "Error"
                });
            }
        },

        adjustStorageColumns(){
            this.headers.forEach((header, i) => {
                    let visibility = this.visibleColumns.find(x => x.column == header.value)
                    if (!visibility) {
                        this.visibleColumns.splice(i, 0,{
                            column: header.value,
                            isVisible: true
                        });
                    }
                })
        }
    },

    watch: {
        visibleColumns:{
            handler(val, oldVal) {
                if (val) {
                    this.setVisibleColumns(val)
                    
                }
            },
            deep: true
        },
        options: {
            handler(val, oldVal) {
                if (val.sortBy[0]) {
                    this.filtersData.order = val.sortBy[0].split("[")[0];

                    if (val.sortDesc) {
                        this.filtersData.order +=
                            "," + (val.sortDesc[0] ? "desc" : "asc");
                    }

                    if (
                        oldVal.sortDesc[0] === undefined ||
                        oldVal.sortDesc[0] !== val.sortDesc[0]
                    ) {
                        if (this.page !== 1) {
                            this.page = 1;
                        } else {
                            this.getFilteredData();
                        }
                    }
                }
            },
            deep: true
        },
        optionsStoreCustomers: {
            handler(val, oldVal) {
                if (val.sortBy[0]) {
                    this.filtersData.order = val.sortBy[0].split("[")[0];

                    if (val.sortDesc) {
                        this.filtersData.order +=
                            "," + (val.sortDesc[0] ? "desc" : "asc");
                    }

                    if (
                        oldVal.sortDesc[0] === undefined ||
                        oldVal.sortDesc[0] !== val.sortDesc[0]
                    ) {
                        if (this.page !== 1) {
                            this.page = 1;
                        } else {
                            this.getFilteredData();
                        }
                    }
                }
            },
            deep: true
        },
        $route(val) {
            if (!val.query.page) {
                this.$router.push({
                    query: {
                        page: 1,
                        ...this.$route.query
                    }
                });
            }
            this.getFilteredData();
        },

        page(page) {
            this.$router.push({ query: { ...this.$route.query, page } });
        },

        search(val, oldVal) {
            if (val != oldVal) {
                this.page = 1;
            }
            if (val == null) {
                this.getFilteredData();
            } else {
                this.debouncedSearch();
            }
        },

        searchAttributes(val, oldVal) {
            if (val == null) {
                this.getAttributes(this.attributesQuery);
            } else {
                this.debouncedSearchAttributes();
            }
        },
        // searchStoreCustomers(val) {
        //     if (val == null) {
        //         this.getFilteredData();
        //     } else {
        //         this.debouncedSearch();
        //     }
        // },
        searchStores(val) {
            if (val && val.length > 2) {
                this.storesPage = 1;
                this.loadStores({
                    query: this.storesQuery,
                    page: this.storesPage
                });
            }
        },

        exportedFile(val) {
            if (val) {
                if (val.queue) {
                    this.exportCsvStatus = 2;
                } else {
                    this.exportCsvStatus = 3;
                }
            } else {
                this.exportCsvStatus = 1;
            }
        },

        customerTransactionsExportedFile(val) {
            this.exportCsvStatusCustomerTransactions = 1;
            if (val) {
                if (val.queue) {
                    this.exportCsvStatusCustomerTransactions = 2;
                } else if (val.url) {
                    this.exportCsvStatusCustomerTransactions = 3;
                }
            }
        },

        // exportCsvStatusCustomerTransactions(val) {
        //     if (val) {
        //         this.exportCsvStatusCustomerTransactions = 3;
        //         this.setExportCSVStatus(false);
        //     }
        // },

        exportCSVStatus(val) {
            if (val && !this.exportNotificationFileCreated) {
                this.exportCsvStatus = 3;
                this.setExportCSVStatus(false);
            }
        },

        ["selectedAttributeOption"]: {
            handler(val, oldVal) {

                if (val?.value?.length) {
                    if (!this.attributesData?.options?.length) {
                        this.attributesData.options = [];
                    }
                    val.value.forEach((e, i) => {
                        if(!this.attributesData.options?.[i]?.value){
                            this.attributesData.options[i] = {
                                "user_account_attribute_definition_value_id": e.user_account_attribute_definition_value_id,
                                "value": null
                            }
                        }
                        if (e !== null && !(i === 0 && val.value.length === 1)) {
                            this.attributesData.options[i].value = e.value;
                            this.attributesData.options[i].user_account_attribute_definition_value_id = e.user_account_attribute_definition_value_id;
                        }
                    
                    });
                } else {
                    this.attributesData.options = [];
                }
            },
            deep: true
        },

        attributesDialog(val) {
            if (!val) {
                this.attributeOptions.forEach(e => {
                    if (e?.value?.length) {
                        e.value = [{
                            "user_account_attribute_definition_value_id": null,
                            "value": null
                        }];
                    }
                });
            }
        },

        permissions: {
            handler(val, oldVal) {
                if(val && !this.getPermission('customers?.read')){
                    this.$router.replace(
                                `/${this.lang}/${this.panelType}/forbidden-gateway`
                            );
                }
            },
            deep: true
        },

        storePermissions: {
            handler(val, oldVal) {
                if(val && !this.getPermission('customers?.read')){
                    this.$router.replace(
                                `/${this.lang}/${this.panelType}/forbidden-gateway`
                            );
                }
            },
            deep: true
        },
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.push({
                query: {
                    page: 1,
                    ...this.$route.query
                }
            });
        }
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
        this.debouncedSearchAttributes = debounce(
            this.handleSearchAttributes,
            500
        );
    },

    mounted() {
       
        this.getFilteredData();
        this.getExportedFileStatus();
        this.getExportedFileStatus("transactions");
        this.loadStores({
            page: this.storesPage,
            query: this.storesQuery
        });
        // if (!this.attributes?.length) {
            this.getAttributes();
        // }
        this.adjustStorageColumns()
    }
};
</script>
<style scoped>
.menu-tab {
    margin-top: 0;
    margin-left: 0;
    max-width: 300px;
    position: absolute;
    left: 0;
    background: white;
    width: 100%;
    text-align: left;
    bottom: -22px;
}
.droptab {
    max-width: 300px;
    min-width: 200px;
    margin-left: 10px;
    margin-right: 10px;
    color: white;
}
</style>

<style>
.droptab * {
    text-align: center;
}
.menu-tab .v-input__slot::before {
    border: none !important;
}
.menu-tab .v-input__slot .v-input__append-inner {
    display: none;
}
.menu-tab
    .v-text-field.v-input--is-focused
    > .v-input__control
    > .v-input__slot::after {
    display: none;
}
.menu-tab .v-label {
    text-align: center;
    padding-left: 10px;
    width: 100%;
}
.no-border-field * {
    border: none !important;
}
.input-text-center input {
    text-align: center;
}
.table-chips {
    max-height: 200px;
    overflow: auto;
}
.table-chips .v-slide-group__wrapper {
    overflow: auto;
}
</style>
